import React from "react";
import { THEME } from "../../constants/theme";

export const Button = ({
    children,
    variant = "primary",
    size = "md",
    disabled = false,
    className = "",
    ...props
}) => {
    const variants = {
        primary: "bg-amber-500 hover:bg-amber-600 text-zinc-900",
        secondary: "bg-zinc-800 hover:bg-zinc-700 text-zinc-100 border border-zinc-700",
        outline: "border border-amber-500/50 hover:bg-amber-500/10 text-amber-500",
        danger: "bg-red-500 hover:bg-red-600 text-white",
        success: "bg-green-500 hover:bg-green-600 text-white",
    };

    const sizes = {
        sm: "px-4 py-2 text-sm",
        md: "px-6 py-3",
        lg: "px-8 py-4 text-lg",
    };

    const baseClasses =
        "rounded-xl font-medium transition-all duration-200 flex items-center justify-center";

    return (
        <button
            className={`${
                variants[variant]
            } inline-flex items-center justify-center px-4 py-2 rounded-xl transition-colors transition-transform transform hover:scale-105 ${className} ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            {...props}
        >
            {children}
        </button>
    );
};
